DYC.filter('short', function () {
    return function (text, length) {
        if (text && text.length > length) {
            return text.substring(0, length) + '...';
        } else {
            return text;
        }
    };
});


// WEBPACK FOOTER //
// ./src/common/filter/ellipsis.js